import React from 'react';
import { Link, useLocation } from 'react-router-dom';

/**
 * AuthNavbar Component
 * 
 * Top navigation bar for authentication pages (login/register).
 * Features tab switching and action buttons.
 * 
 * Exact styles from auth.css:
 * - Height: 64px
 * - Padding: 0 40px (0 2.5rem)
 * - Background: rgba(0, 0, 0, 0.2) with backdrop blur 10px
 * - Border bottom: 1px solid rgba(255, 255, 255, 0.1)
 */
const AuthNavbar = () => {
  const location = useLocation();
  const isLogin = location.pathname === '/login';

  return (
    <nav
      className="top-nav h-16 border-b border-white/10 flex items-center justify-between px-10 fixed top-0 left-0 right-0 z-[100]"
      style={{
        background: 'rgba(0, 0, 0, 0.2)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
      }}
    >
      {/* Tab Group */}
      <div className="tab-group inline-flex items-center gap-4 bg-white/5 py-1 px-2 rounded-full shadow-tab-group">
        <Link
          to="/login"
          className={`tab bg-transparent border-none text-[15px] px-[22px] py-2 rounded-full cursor-pointer transition-all duration-160 active:scale-[0.98] ${
            isLogin
              ? 'tab-active bg-white/15 text-white'
              : 'text-[#9ca3af] hover:bg-[#f3f4f6] hover:-translate-y-px hover:shadow-[0_4px_10px_rgba(15,23,42,0.08)]'
          }`}
        >
          Login
        </Link>
        <Link
          to="/register"
          className={`tab bg-transparent border-none text-[15px] px-[22px] py-2 rounded-full cursor-pointer transition-all duration-160 active:scale-[0.98] ${
            !isLogin
              ? 'tab-active bg-white/15 text-white'
              : 'text-[#9ca3af] hover:bg-[#f3f4f6] hover:-translate-y-px hover:shadow-[0_4px_10px_rgba(15,23,42,0.08)]'
          }`}
        >
          Register
        </Link>
      </div>

      {/* Auth action buttons */}
      <div className="auth-group flex gap-3">
        <Link
          to="/"
          className="auth-btn rounded-full text-[13px] px-4 py-2 cursor-pointer border border-white/30 bg-transparent text-white transition-all duration-160 hover:-translate-y-px hover:shadow-[0_6px_14px_rgba(15,23,42,0.12)] hover:bg-white/5 active:scale-[0.98] no-underline"
        >
          ← Home
        </Link>
      </div>
    </nav>
  );
};

export default AuthNavbar;

